module.exports = __webpack_public_path__ + "static/media/Sol.1672c729.svg";